import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';

const Home = ({ user }) => {
  const navigate = useNavigate();

  // Logged-in users go directly to Files
  if (user) {
    return <Navigate to="/files" replace />;
  }

  return (
    <div className="hero">
      <img src="/NightBacon.png" alt="Night Bacon" className="hero-image" />
      <div className="hero-content">
        <h1 className="hero-title">Night Bacon Portal</h1>
        <p className="hero-subtitle">
          A collaborative space for band members to share and work on music together.
        </p>
        <button onClick={() => navigate('/login')}>Sign In</button>
      </div>
    </div>
  );
};

export default Home;
